export function clubs (state, clubs) {
	state.clubs = [ ...clubs ];
}
